
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ExtendedContactInfo from "@/apps/shared/components/ExtendedContactInfo.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        name: 'tabOne',
        components: {
            XBreadcrumb,
            ExtendedContactInfo,
            TitleAndPromotions,
        },
        data() {
            return {
                sendDataDiscount: null,
                titleAndPromotionDetails: {
                    title: "",
                    subTitle: "",
                    product: "",
                    icon: {
                        src: '/Logos/retiro.png',
                        alt: 'Retiro',
                        title: 'Retiro'
                    },
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                name: null,
                lastName: null,
                telephone: '',
                areaCode: '',
                email: null,
                discountRate: null,
                fechaPromotions: null,
                changeTitlePromotions: false,
                containDiscountRange: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/calculadoraretiro' },
                ],
                leadId: null,
                referente: null
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Seguro de Retiro';
                const actualPath = '/calculadoraretiro';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            comenzar() {
                const extendedContactInfoData = this.$refs.extendedContactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { firstName, lastName, email, telephone, areaCode, validTelephone, validEmail } = extendedContactInfoData;
                this.firstName = firstName;
                this.lastName = lastName;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                const validName = firstName && firstName.trim() !== "";
                const validLastName = lastName && lastName.trim() !== "";
                const validateEmail = validEmail;
                if (validName && validLastName && this.validatePhone && validateEmail) {
                    NF.UI.Page.block();
                    sessionStorage.setItem("DataClient", JSON.stringify({
                        firstName: this.firstName,
                        lastName: this.lastName,
                        areaCode: this.areaCode,
                        telephone: this.telephone,
                        email: this.email
                    }));

                    return new Promise<any>(async (resolve) => {
                        this.$router.push({
                            name: 'cotizador-retiro',
                        })
                    })
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                await this.pageCustomization();

                sessionStorage.setItem("ExitOrContinueModal", "true");

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
